import { produce } from 'immer';
import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_APPLICATION_ACTION_TYPE } from '../actions';

const initialState = {};

const loanApplicationChecklistResultsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_APPLICATION_ACTION_TYPE.GET_CHECKLIST_RESULTS:
        return payload || initialState;

      // Optimistic suppress (DEV-4468): patch the targeted item as overridden so
      // the field-completeness indicator flips on the click; the eventual SignalR
      // snapshot push reconciles the slice with server truth.
      //
      // The slice is keyed by `${checklistId}:${targetId}` (DEV-4684), so once the caller knows
      // the specific target (loan or borrower) it looks the snapshot up directly via that key —
      // otherwise a Borrower-scoped override could collide with a sibling borrower's snapshot
      // that shares the same checklistId. `targetId` is optional so an older caller that only
      // knows the checklistId still resolves (falls back to the first match, as before DEV-4684).
      case LOAN_APPLICATION_ACTION_TYPE.OPTIMISTICALLY_OVERRIDE_CHECKLIST_ITEM: {
        const { checklistId, itemId, targetId, isOverridden = true } = payload;
        const snapshot = _.isNil(targetId)
          ? Object.values(draft).find(entry => entry?.target?.checklistId === checklistId)
          : draft[`${checklistId}:${targetId}`];
        const item = snapshot?.status?.result?.items?.find(
          ({ checklistItemId }) => checklistItemId === itemId,
        );

        if (item) {
          item.wasOverriden = isOverridden;

          // Reverting (toast Undo, DEV-5146) must also drop pending Override
          // entries — `isItemOverridden` treats either signal as suppressed, so
          // leaving them would keep the item reading as overridden.
          if (!isOverridden && item.overrideHistory) {
            item.overrideHistory.wasOverriden = false;
            item.overrideHistory.entries = item.overrideHistory.entries?.filter(
              entry => entry?.change?.type !== 'Override',
            );
          }
        }

        break;
      }

      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default loanApplicationChecklistResultsReducer;
